import React, { useEffect, useRef } from 'react';
import './products.css';

const Products = () => {
    // Reveal animation logic
    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('visible');
                }
            });
        }, { threshold: 0.15 });

        const boxes = document.querySelectorAll('.product-card');
        boxes.forEach((box) => observer.observe(box));

        return () => {
            boxes.forEach((box) => observer.unobserve(box));
        };
    }, []);

    const productsData = [
        {
            id: 1,
            title: "Agarwood (Aquilaria spp.)",
            subtitle: "Wood Bearing Crops",
            image: "https://res.cloudinary.com/drevfgyks/image/upload/v1729503605/AMARAVATHI%20NATURO%20TECH%20PVT%20LTD/agree_us4ltq.jpg",
            descriptions: [
                "Wood bearing crops include trees and plants cultivated primarily for their timber, which is used in construction, furniture, and paper production.",
                "Agarwood is a resinous heartwood formed in trees of the Aquilaria genus, most notably when infected by a specific type of mold. This resin is incredibly rare and is used to create a rich, smoky aroma."
            ],
            extraContent: {
                title: "Health Benefits",
                items: [
                    "Anti-inflammatory and Analgesic Effects",
                    "Antioxidant Properties",
                    "Digestive Health",
                    "Stress Relief and Mental Clarity",
                    "Antimicrobial and Antifungal Properties"
                ]
            }
        },
        {
            id: 2,
            title: "Mahogany (Swietenia spp.)",
            image: "https://res.cloudinary.com/drevfgyks/image/upload/v1729503605/AMARAVATHI%20NATURO%20TECH%20PVT%20LTD/moho_urpmzo.jpg",
            descriptions: [
                "Mahogany is one of the most popular and durable hardwoods used globally, known for its deep reddish-brown color and fine grain. It is commonly grown in Central and South America as well as parts of Africa and Southeast Asia.",
                "Uses: Perfume and incense production, traditional medicine, and ornamental wood carving."
            ],
            extraContent: {
                title: "Related: Rosewood",
                desc: "Rosewood is a prized hardwood known for its striking color and fine grain. Valued for its durability and unique aroma, it is commonly used in the production of luxury furniture."
            }
        },
        {
            id: 3,
            title: "White Sandalwood",
            subtitle: "(Santalum album)",
            image: "https://res.cloudinary.com/drevfgyks/image/upload/v1729941629/AMARAVATHI%20NATURO%20TECH%20PVT%20LTD/WhatsApp_Image_2024-10-23_at_13.08.20_6ec09beb_txg12u.jpg",
            descriptions: [
                "White Sandalwood, known for its fragrant heartwood, is one of the most precious woods in the world. It is predominantly cultivated in India, Australia, and Southeast Asia.",
                "Sustainability: White Sandalwood trees take decades to mature, making long-term investment in sustainable agroforestry essential."
            ]
        },
        {
            id: 4,
            title: "Red Sandalwood",
            subtitle: "(Pterocarpus santalinus)",
            image: "https://res.cloudinary.com/drevfgyks/image/upload/v1729941629/AMARAVATHI%20NATURO%20TECH%20PVT%20LTD/WhatsApp_Image_2024-10-23_at_13.07.19_f86e2a5b_sqxned.jpg",
            descriptions: [
                "Red Sandalwood, also known as Rakta Chandana, is a highly valued hardwood primarily grown in southern India. It is renowned for its deep red hue and rich grain patterns.",
                "Uses: Widely used in high-end furniture, handicrafts, and natural dye production."
            ]
        },
        {
            id: 5,
            title: "Rose wood",
            subtitle: "(Dalbergia latifolia)",
            image: "https://res.cloudinary.com/dexueorjm/image/upload/v1776844897/Ross_wood_aa5sg8.png", // Using a placeholder for now, replace with actual if provided
            descriptions: [
                "Rose wood is a prized hardwood known for its striking color and fine grain. Valued for its durability and unique aroma, it is commonly used in the production of luxury furniture."
            ]
        },
        {
            id: 6,
            title: "Exotic Fruits Crops",
            image: "https://res.cloudinary.com/dexueorjm/image/upload/v1776845309/MACADAMIA_j2acak.png",
            descriptions: [
                "Exotic fruit crops are a rich source of essential vitamins, minerals, and nutrients. Include: Avocado, Macadamia, and Dragon Fruit."
            ]
        },
        {
            id: 7,
            title: "Medicinal Crops",
            image: "https://res.cloudinary.com/drevfgyks/image/upload/v1725105498/AMARAVATHI%20NATURO%20TECH%20PVT%20LTD/7_vndxzw.png",
            descriptions: [
                "Medicinal crops are cultivated for their therapeutic properties (Aloe vera, Turmeric). They play a vital role in both nutrition and healthcare."
            ]
        },
        {
            id: 8,
            title: "Aromatic Crops",
            image: "https://res.cloudinary.com/dexueorjm/image/upload/v1772688733/PHOTO-2026-03-02-09-52-46_3_quhd4r.jpg",
            descriptions: [
                "Aromatic crops are cultivated for their rich therapeutic, aromatic, and industrial value (Lemongrass, Mint, Davana)."
            ]
        },
        {
            id: 9,
            title: "Spices Crops",
            image: "https://images.unsplash.com/photo-1596040033229-a9821ebd058d?q=80&w=600&h=450&auto=format&fit=crop", // placeholder
            descriptions: [
                "Unlock the true aroma and flavor of spices with our specialized farming inputs."
            ]
        }
    ];

    return (
        <div className="products-page">
            <div className="products-hero">
                <h1>Our Premium Products</h1>
                <p>Sustainable, High-Quality, and Naturally Sourced</p>
                <div className="hero-divider"></div>
            </div>

            <div className="products-grid-container">
                {productsData.map((product, index) => (
                    <div
                        key={product.id}
                        className={`product-card ${index % 2 === 0 ? 'image-left' : 'image-right'}`}
                    >
                        <div className="product-image-wrapper">
                            <img src={product.image} alt={product.title} className="product-img" />
                            <div className="img-decoration"></div>
                        </div>

                        <div className="product-content">
                            <h2 className="product-title">
                                {product.title}
                                {product.subtitle && <span className="product-subtitle"><br />{product.subtitle}</span>}
                            </h2>
                            <div className="title-underline"></div>

                            {product.descriptions.map((desc, i) => (
                                <p key={i} className="product-text">{desc}</p>
                            ))}

                            {product.extraContent && (
                                <div className="expert-insight">
                                    <h3>{product.extraContent.title}</h3>
                                    {product.extraContent.desc && <p>{product.extraContent.desc}</p>}
                                    {product.extraContent.items && (
                                        <ul>
                                            {product.extraContent.items.map((item, i) => (
                                                <li key={i}>{item}</li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>

            <div className="eof-section">
                <p className="EFE">Emerging Farmers Empowerment</p>
            </div>
        </div>
    );
};

export default Products;
